import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b983451")

_pushScopeId("data-v-7b983451")
const _hoisted_1 = { class: "hue" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "hue-picker" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "hue-container",
      ref: "hueRef",
      onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleMouseDown($event))
    }, [
      _createVNode("div", {
        class: "hue-pointer",
        style: { left: _ctx.pointerLeft }
      }, [
        _hoisted_2
      ], 4)
    ], 544)
  ]))
})